export interface QuizQuestion {
  id: string;
  questionText: string;
  groupId: string | undefined;
  difficulty: number;
  score: number;
  reference: BibleReference;
  explanation: string | undefined;
  questionType: QuestionType;
  options: QuizOption[] | undefined;
  correctOptionId: string | undefined;
  simpleAnswer: string | undefined;
  createdById: string | undefined;
  createdByName: string | undefined;
  createdByPhotoUrl: string | undefined;
  modified: Date | undefined;

  userAnswer?: string;
  isCorrect?: boolean;
  aiExplanation?: string;
  userId?: string;
  userName?: string;
  photoUrl?: string;
  tags?: string[];
  embedding?: number[];
  embeddingTokens?: number;
}

export interface QuizOption {
  id: string;
  text: string;
}

export interface BibleReference {
  book: string;
  chapter: number | undefined;
  verse: number | undefined;
}

export enum QuestionType {
  multipleChoice = 'Multiple Choice',
  fillInTheBlank = 'Fill In The Blank',
  trueFalse = 'True/False',
  shortAnswer = 'Short Answer',
}
